<template>
  <main class="md:p-4 max-w-xl">
    <sqr-progress v-show="loading" />
    <sqr-page-header title="Brokers" class="p-4" />
    <sqr-error-banner :error="loadError" />
    <div class="bg-white shadow overflow-hidden sm:rounded-md">
      <ul>
        <li
          v-for="broker in brokers"
          :key="broker.id"
          class="border-t border-gray-200 first:border-t-0"
        >
          <router-link
            :to="{ name: 'broker', params: { bid: broker.id } }"
            class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
          >
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <div
                  class="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4"
                >
                  <div>
                    <div
                      class="text-sm leading-5 font-medium text-blue-600 truncate"
                    >
                      {{ broker.name }}
                    </div>
                  </div>
                  <div class="hidden md:block"></div>
                </div>
              </div>
              <div>
                <fa :icon="['far', 'chevron-right']" />
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex';
import SqrErrorBanner from '@/sqrd-ui/SqrErrorBanner';
// @ is an alias to /src

export default {
  name: 'home',
  components: { SqrErrorBanner },
  computed: {
    ...mapState('brokers', ['loading', 'brokers', 'loadError'])
  },
  metaInfo: {
    title: 'Brokers'
  }
};
</script>
